import { api } from '@/api'
import type { Offer, OfferFilters } from '@/api/typings/offer.typing'
import type { ApiGenericResponse } from '@/api/typings/response.typing'

export function getOffersAction(filters: OfferFilters = {}): Promise<ApiGenericResponse<Offer[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/offers?${params.toString()}`

  return api.get<ApiGenericResponse<Offer[]>>(url)
}
